/** Grid field names for V2 (argo model) score columns: `mscore_<family>_<column>`.
 * Pure helpers (no React/MUI) so they stay runnable under `node --test`. */

export const MODEL_SCORE_SORT_COLUMNS = [
  "composite",
  "fit",
  "need",
  "intent",
] as const;
export type ModelScoreSortField = (typeof MODEL_SCORE_SORT_COLUMNS)[number];

export const MODEL_SCORE_PILLARS = ["fit", "need", "intent"] as const;
export type ModelScorePillar = (typeof MODEL_SCORE_PILLARS)[number];

export const MODEL_SCORE_PILLAR_LABELS: Record<ModelScorePillar, string> = {
  fit: "Fit",
  need: "Need",
  intent: "Intent",
};

/** Field name for one of a model's score columns. The Total column uses
 * `composite` so sorting it maps to `model_score_sort.composite`. `tier` is
 * never a field: it's not server-sortable (lexical order misleads). */
export const modelScoreField = (family: string, column: ModelScoreSortField) =>
  `mscore_${family}_${column}`;

/**
 * Parses `mscore_<family>_<column>` back into its parts, or null if the field
 * isn't a sortable V2 model-score column. `family` is a nanoid that can itself
 * contain `_`, so the known suffix is stripped rather than split on.
 */
export function parseModelSortField(
  field: string
): { family: string; column: ModelScoreSortField } | null {
  if (!field.startsWith("mscore_")) return null;
  for (const column of MODEL_SCORE_SORT_COLUMNS) {
    const suffix = `_${column}`;
    if (!field.endsWith(suffix)) continue;
    const family = field.slice("mscore_".length, -suffix.length);
    return family ? { family, column } : null;
  }
  return null;
}
